// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"bbb3294e","513":"2c61ed14","787":"601ba1d7"}[chunkId] + ".chunk.js";
};